import ct from "class-types.macro";
import React from "react";

interface Props {
  searchValue: string;
}

function SearchResultNotFound({ searchValue }: Props) {
  return (
    <>
      <div className="support-results clears">
        <span className="header-2">
          Results for{" "}
          <span className={ct("text-green-500")}>{searchValue}</span>
        </span>
        <div className="no-results">
          <span className="header-3">
            Sorry, we were unable to find an answer to your search.
          </span>
          <p>
            Get in touch with a Customer Solutions Specialist using the form
            below or via our{" "}
            <a className="basic-text-chat" target="_blank" href="/chat/">
              Live Chat
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

export default SearchResultNotFound;
